import axios from "axios";
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store  = new Vuex.Store({
    state:{
        BottomPlay:false,//底部播放栏是否显示
        ralTiShow:false,//底部大的播放器
        userInfo:JSON.parse(localStorage.getItem('YousrDL')) || [{id:0,image:'../assets/img-today-0364456e.png',username:'无'}],//用户登录信息
        isLoggedIn:!!localStorage.getItem('YousrDL'),//是否已登录
        Geren:[],//用户的个人信息,修改操作
        SongInfo:{},//歌曲信息,用于播放
        SongURL:'',//歌曲下载地址
        SongId:-1,//歌曲ID
        showLoginDialog:false,//是否显示登录对话框
        isPlaying:false,//播放状态
    },
    mutations:{
        //是否显示底部播放栏是否显示
        PlayerStatus(state,value){
            state.BottomPlay = value;
            state.ralTiShow = value;
        },
        // 设置用户信息
        setUserInfo(state, userInfo){
            state.userInfo = userInfo;
            // 更新登录状态
            state.isLoggedIn = !!(userInfo && (userInfo.username || userInfo.id));
        },
        //修改歌曲播放id
        setSongId(state, Id){
            state.SongId = Id;
        },
        //设置歌曲信息
        setSongInfo(state, songInfo){
            state.SongInfo = songInfo;
        },
        //设置播放状态
        setPlaying(state, value){
            state.isPlaying = value;
        },
        //下载歌曲
        DownloadSongs(state,urls){
            // console.log('歌曲路径：',urls);
            state.SongURL = urls.audio_url;
            let filename = `${urls.Name}.mp3`; //如123.xls
            let a = document.createElement("a");
            // blob.type = "application/octet-stream";
            //创键临时link对象
            let url = window.URL.createObjectURL(new Blob([state.SongURL]));
            console.log(url)

            a.href = url;
            a.download = filename;
            a.click();
             // 使用Blob来处理文件的下载
            //  fetch(state.SongURL).then(response => {
            //     if (!response.ok) {
            //         throw new Error('网络错误');
            //     }
            //         return response.blob(); // 将数据转换为Blob对象
            //     })
            //     .then(blob => {
            //         const url = window.URL.createObjectURL(blob); // 创建Blob URL
            //         const a = document.createElement('a'); // 创建一个链接元素
            //         a.href = url; // 设置href
            //         a.download = `${urls.Name}.mp3`; // 文件名
            //         document.body.appendChild(a);
            //         a.click(); // 触发下载
            //         a.remove(); // 移除链接元素
            //         window.URL.revokeObjectURL(url); // 释放资源
            //         this.$message.error('已加入下载列表中');
            //     })
            //     .catch(error => {
            //         console.error('下载失败', error);
            //     });
        },
        //添加收藏歌曲到列表
        SHOUCANG(state,songSC){
            console.log(!songSC.Action);
            axios.post('/shoucang',{
                id:songSC.ID,
                phone:state.userInfo[0].phone,
                action:songSC.Action = !songSC.Action
            })
            .then(response => {
                console.log('获取收藏信息成功:', response.data);
                // if(response.data.data.code == 1){
                //     this.$message.success('收藏成功');
                // }else{
                //     this.$message.error('已取消收藏');
                // }
            }).catch(error => {
                console.error('获取收藏信息失败:', error);
            })
        },

        //显示个人信息
        GerenInfo(state,value){
            state.Geren = value;
        }
    }
})
export default store;